import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import { useAuthStore } from './auth'

// Shared with Vue 2; preferences belong to the current user, including masquerade.
const STORAGE_KEY = 'coachsight.betaPreferences'
function loadPreferences(): Record<string, boolean> {
  try {
    const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}')
    return value && typeof value === 'object' && !Array.isArray(value) ? value : {}
  } catch { return {} }
}

export const useBetaStore = defineStore('beta', () => {
  const auth = useAuthStore()
  const preferences = ref(loadPreferences())
  const userId = computed(() => String(auth.user?.details?.id || auth.user?.id || ''))
  const eligible = computed(() => Boolean(auth.user?.details?.beta))
  const enabled = computed(() => eligible.value && Boolean(userId.value) && preferences.value[userId.value] !== false)
  function toggle() {
    if (!eligible.value || !userId.value) return
    preferences.value = { ...preferences.value, [userId.value]: !enabled.value }
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(preferences.value)) } catch { /* Keep the control usable without storage. */ }
  }
  return { eligible, enabled, toggle }
})
